import { recordToLang } from '../../utils';
import homePage from './homePage';
import campaign from './campaign';
import campaignRequest from './campaignRequest';
import breadcrumbs from './breadcrumbs';

const lang: Record<string, string> = recordToLang({
    homePage,
    campaign,
    campaignRequest,
    breadcrumbs,
});

export default lang;
